module.exports = __webpack_public_path__ + "img/icon_line_def.3a25b662.svg";